// extracted by mini-css-extract-plugin
export default {"root":"DeployAvatarConfirm_root__WcNgz","layout-container":"DeployAvatarConfirm_layout-container__LPcKI","content":"DeployAvatarConfirm_content__nezpR","button":"DeployAvatarConfirm_button__m0Pg-","actionsContainer":"DeployAvatarConfirm_actionsContainer__JesHZ"};
    if(module.hot) {
      // 1763446807944
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  